import { createContext } from 'react';

import type { PageResponse } from '../types';

type PageContextValue = {
  page: PageResponse;
};

const PageContext = createContext<PageContextValue>({} as PageContextValue);

export { PageContext };
